import { HashAnchorScroll } from "@components/atoms/HashAnchorScroll"
import { Header } from "@components/site/Header"
import { ContentBlocks } from "eddev/blocks"
import { defineView } from "eddev/views"

export const meta: ViewMeta = {
  templateName: "Terms Page",
}

export default defineView("template-terms", (props) => {
  return (
    <>
      <Header noPattern />
      <div className="relative w-full mx-auto md:max-w-termsMaxW pt-landingSpaceTop">
        <ContentBlocks blocks={props.page?.contentBlocks} />
      </div>
      <HashAnchorScroll />
    </>
  )
})
